import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Select from 'react-select'
import CustomSelect from '../Utilities/CustomSelect';
import { EditClientSubscribeVM } from '../../Structure/ViewModels/Accountant/EditClientSubscribeVM';
import { mainPath } from '../../Structure/Constants/MainPath';
import CustomImageUpload from '../Utilities/CustomImageUpload';
import { SubscriptionData, TraineeSubscription } from '../../Structure/Models/Trainee';

const EditClientSubscribe = (props:{subs:TraineeSubscription,subName:string , name:string, id:string}) => {
  const [vm,setVm] = useState<{viewModel:EditClientSubscribeVM}>({viewModel: new EditClientSubscribeVM(props.subs,props.name)})
  const control = vm.viewModel
  useEffect(()=>{ 
    control.getLists(props.id,props.subName)
    control.subscribeUpdate(setVm); 
  }, [])
  
  return (
    <Container>
      <Row className='py-5'>
        <h3 className='fw-bold text-center txt-color-I'>اضافة اشتراك</h3>
      </Row>
      <Row className='pb-5'>
      <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
        <Row  className='w-100'>
          <Col md={12} className='d-flex justify-content-around'>
            <label className='my-auto py-2 py-md-0'>الاسم</label>
            <label className='my-auto py-2 py-md-0 txt-color-I fw-bold'>{control.Data.name}</label>
          </Col>
        </Row>
      </Col>
      <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
        <Row  className='w-100'>
          <Col md={12} className='d-flex justify-content-around'>
            <label className='my-auto py-2 py-md-0'>السعر</label>
            <label className='my-auto py-2 py-md-0 txt-color-I fw-bold'>{control.Price}</label>
          </Col>
        </Row>
      </Col>
      </Row>
      <Row className='pb-5'>
      <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
        <Row  className='w-100'>
          <Col md={12} className='d-flex justify-content-around'>
            <label className='my-auto py-2 py-md-0'>سعر العملة</label>
            <label className='my-auto py-2 py-md-0 txt-color-I fw-bold'>{control.CurrencyPrice}</label>
          </Col>
        </Row>
      </Col>
      <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
        <Row  className='w-100'>
          <Col md={12} className='d-flex justify-content-around'>
            <label className='my-auto py-2 py-md-0'>السعر المحلى</label>
            <label className='my-auto py-2 py-md-0 txt-color-I fw-bold'>
              {
                control.LocalPrice
              }
            </label>
          </Col>
        </Row>
      </Col>
      </Row>
      <Row className='border p-3'>
        <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
          <Row  className='w-100'>
            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
              <label htmlFor="marketier" className='my-auto py-2 py-md-0'>التخصص</label>
            </Col>
            <Col md={8}>
              <CustomSelect list={control.LevelSpecializations} selected={control.Data.levelSpecializations_id} onSelect={a=>control.Specialization = a} />
            </Col>
          </Row>
        </Col>
        <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
          <Row  className='w-100'>
            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
              <label htmlFor="marketier" className='my-auto py-2 py-md-0'>نوع الحساب</label>
            </Col>
            <Col md={8}>
              <CustomSelect list={control.Accounts} selected={control.Data.account_id} onSelect={a=>control.Account=a} />
            </Col>
          </Row>
        </Col>
        <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
          <Row  className='w-100'>
            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
              <label htmlFor="marketier" className='my-auto py-2 py-md-0'>التوثيق</label>
            </Col>
            <Col md={8}>
              <CustomSelect list={[{label:'توثيق', value:'verify'} , {label:'بدون توثيق' , value:'no verify'}]} selected={control.Data.verification} onSelect={a=>control.Verification=a} />
            </Col>
          </Row>
        </Col>
        <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
          <Row className='w-100'>
            <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
              <label htmlFor="purchased" className='my-auto py-2 py-md-0'>خصم </label>
            </Col>
            <Col md={8}>
              <input id='purchased' type="text" className='w-100 input-field' value={control.Data.discount} onChange={a=>control.Discount=a.target.value} placeholder='خصم...' />
            </Col>
          </Row>
        </Col>
        <Row className=' justify-content-center pt-3'>
          <Col lg={12} className='d-flex justify-content-center px-3 py-3 pt-5'>
              <button className='button-I btn-cl-I mx-3 p-1 px-5 fs-5 ' onClick={()=>control.send()}>حفظ</button>
          </Col>
        </Row>
      </Row>
    </Container>
  )
}

export default EditClientSubscribe
